import type { ContentTooltipProps } from "./content-tooltip";
import { CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS } from "./content-tooltip-sizes";

/**
 * Prop bags for Prefer-over consumers — spread into ContentTooltip.
 * Not wrapper components (hard-cut: no shim dual paths).
 */

/** Chrome CircleButtons / short labels — anchored + arrow. */
export const CONTENT_TOOLTIP_SHORT = {
	surface: "default",
	colorScheme: "system",
	size: "sm",
	transition: "fadeZoom",
	delayDuration: CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS,
	followCursor: false,
	interactive: false,
	dismissOnTriggerLeave: true,
	autoPlace: true,
	openOn: "hoverAndTap",
} as const satisfies Partial<ContentTooltipProps>;

/**
 * Actionable chrome (header CircleButtons, HUD triggers) — hover to tip;
 * click activates the control and must not open/toggle the tip.
 */
export const CONTENT_TOOLTIP_CHROME = {
	...CONTENT_TOOLTIP_SHORT,
	openOn: "hover",
} as const satisfies Partial<ContentTooltipProps>;

/**
 * Dense HUD short tips — cursor follow, no arrow, no bridge.
 * Use for capacity/empty-slot labels (not rich ability bodies).
 */
export const CONTENT_TOOLTIP_HUD = {
	surface: "default",
	colorScheme: "system",
	size: "sm",
	transition: "fadeZoom",
	delayDuration: CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS,
	followCursor: true,
	interactive: false,
	dismissOnTriggerLeave: true,
	autoPlace: true,
	lazyMount: true,
	openOn: "hoverAndTap",
} as const satisfies Partial<ContentTooltipProps>;

/**
 * Rich ability / inventory / quote / learn-stop — forced dark shell,
 * follow cursor, no arrow, no bridge. Inner content keeps white-on-dark layouts.
 */
export const CONTENT_TOOLTIP_ABILITY_DARK = {
	surface: "default",
	colorScheme: "dark",
	transition: "fadeZoom",
	delayDuration: CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS,
	followCursor: true,
	interactive: false,
	dismissOnTriggerLeave: true,
	autoPlace: true,
	lazyMount: true,
	openOn: "hoverAndTap",
} as const satisfies Partial<ContentTooltipProps>;

/** Loot Prefer glass + spring tilt; anchored above trigger; no arrow. */
export const CONTENT_TOOLTIP_LOOT = {
	surface: "glass",
	transition: "springTilt",
	delayDuration: CONTENT_TOOLTIP_DEFAULT_OPEN_DELAY_MS,
	followCursor: false,
	showArrow: false,
	side: "top",
	align: "center",
	interactive: false,
	dismissOnTriggerLeave: true,
	colorScheme: "invert",
	autoPlace: true,
	lazyMount: true,
} as const satisfies Partial<ContentTooltipProps>;
